import {
  Tooltip as MuiTooltip,
  TooltipProps as MuiTooltipProps,
} from '@mui/material';

import { BaseComponentProps } from './types';

export interface TooltipProps
  extends Omit<BaseComponentProps, 'title'>,
    Pick<
      MuiTooltipProps,
      | 'title'
      | 'children'
      | 'flipped'
      | 'placement'
      | 'arrow'
      | 'open'
      | 'disableFocusListener'
      | 'disableHoverListener'
      | 'disableTouchListener'
      | 'onClose'
      | 'PopperProps'
      | 'slotProps'
      | 'enterDelay'
    > {}

export const Tooltip = ({ children, ...tooltipProps }: TooltipProps) => (
  <MuiTooltip {...tooltipProps}>{children}</MuiTooltip>
);
